module.exports = __webpack_public_path__ + "static/media/qingdao_pic4.06a398e1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/qingdao_pic4.jpg
 ** module id = 473
 ** module chunks = 0
 **/